import { TrackingManager } from "../../../common/js/services/tracking/trackingManager"

export default () => ({
  internalTracker: null,
  store: null,

  init() {
    this.store = Alpine.store("data")

    this.internalTracker = new TrackingManager(
      window.trackingConfig.enabledTrackingServices,
      pipelineConfig,
    )
  },

  handleContinue() {
    this.internalTracker.trackClick({
      clickName: "Continue Clicked",
    })

    this.store.goToLogin()
  },
})
